import {SupportProgramSettings} from "@/program/interfaces/Program";

const SupportProgramSettingsService = () => {
    return {
        /**
         * First check if the groups is explicitly set by the user via settings.groups.
         * If not, fallback to the default value in Support program meta options.
         * Otherwise, return true.
         */
        isInclusionGroupEnabled(settings: SupportProgramSettings, slug: string): boolean {
            if(settings.groups && settings.groups.find((setting) => setting.group === slug)) {
                return settings.groups.some((setting) => setting.group === slug && setting.enabled);
            }

            return settings.meta.options.notifications[slug] ?? true;
        },

        /**
         * First check if the groups is explicitly set by the user via settings.groups.
         * If not, fallback to the default value in Support program meta options.
         * Otherwise, return false.
         */
        isExclusionGroupEnabled(settings: SupportProgramSettings, slug: string): boolean {
            if (settings.groups && !!settings.groups.find((setting) => setting.group === slug)) {
                return settings.groups.some((setting) => setting.group === slug && setting.enabled);
            }

            return settings.meta.options.notifications[slug] ?? false;
        }
    };
};

export default SupportProgramSettingsService();
